import React, { useState } from 'react'
import { ContextButton } from '@tecuity/granite-ui/ContextButton'
import { SearchBox } from '@tecuity/granite-ui/SearchBox'
import { Spinner } from '../../Loaders/Loaders'
import Portal from 'components/Portal/Portal'
import { Modal } from 'components/Modal/Modal'
import * as api from '../../../requests'

const defaultQuery = {
  FirstName: '',
  LastName: '',
  Email: '',
}

const frequentPayorLabel = process.env.FREQUENT_PAYOR_LABEL

const SettingsUserSearch = ({ onChange, requirePayAccount = true }) => {
  // requirePayAccount=false allows selecting users without a linked pay/prepaid account
  const [userSearchModalOpen, setUserSearchModalOpen] = useState(false)
  const [searchQuery, setSearchQuery] = useState(defaultQuery)
  const [searchResults, setSearchResults] = useState([])
  const [showSearchUserError, setShowSearchUserError] = useState(false)
  const [showSpinner, setShowSpinner] = useState(false)
  const [hasSearchBeenMade, setHasSearchBeenMade] = useState(false)

  const searchForUsers = (query = searchQuery) => {
    setHasSearchBeenMade(true)
    setShowSpinner(true)
    setShowSearchUserError(false)
    api.SEARCH_USERS(
      {
        FirstName: query.FirstName || undefined,
        LastName: query.LastName || undefined,
        Email: query.Email || undefined,
        // FrequentPayorFilter: true, // not in UserSearch/search endpoint yet
      },
      (data) => {
        setShowSpinner(false)
        setSearchResults(
          // .filter((user) => user.PayAccountNum === null)
          data
        )
      },
      (err) => {
        console.error(err)
        setShowSpinner(false)
        setSearchResults([])
      }
    )
  }

  const resetState = () => {
    setUserSearchModalOpen(false)
    setSearchResults([])
    setHasSearchBeenMade(false)
    setSearchQuery(defaultQuery)
    setShowSearchUserError(false)
  }

  const selectUser = (user) => {
    onChange(user)
    resetState()
  }

  return (
    <div>
      <div className="property-label user-search-header">
        <ContextButton onClick={() => setUserSearchModalOpen(true)}>Search Users</ContextButton>
      </div>
      <Portal isOpened={userSearchModalOpen}>
        <Modal
          title="Search Users"
          modalSize="extra-large"
          cancelButton
          autoHeight
          closeModal={() => resetState()}
        >
          <div className="wvm-modal">
            <div className="flex-column-wrapper paper-process-container">
              <div style={{ margin: '5px', padding: '15px' }}>
                <div className="filingSelectButtonWrapper">
                  <SearchBox
                    placeholder={'First Name'}
                    value={searchQuery.FirstName || ''}
                    onChange={(value) =>
                      setSearchQuery((query) => ({ ...query, FirstName: value }))
                    }
                    showClearButton={false}
                    showSearchButton={false}
                    onSubmit={(value) => searchForUsers({ ...searchQuery, FirstName: value })}
                  />
                  <SearchBox
                    placeholder={`Last Name`}
                    value={searchQuery.LastName || ''}
                    onChange={(value) => setSearchQuery((query) => ({ ...query, LastName: value }))}
                    showClearButton={false}
                    showSearchButton={false}
                    onSubmit={(value) => searchForUsers({ ...searchQuery, LastName: value })}
                  />
                  <SearchBox
                    placeholder={`Email`}
                    value={searchQuery.Email || ''}
                    onChange={(value) => setSearchQuery((query) => ({ ...query, Email: value }))}
                    showClearButton={false}
                    showSearchButton={false}
                    onSubmit={(value) => searchForUsers({ ...searchQuery, Email: value })}
                  />
                  <div elevation="standard" className="search-bar">
                    <ContextButton
                      variant="danger"
                      onClick={() => {
                        setSearchQuery(defaultQuery)
                        setHasSearchBeenMade(false)
                        setSearchResults([])
                        setShowSearchUserError(false)
                      }}
                    >
                      Clear
                    </ContextButton>
                    <ContextButton variant="primary" onClick={() => searchForUsers()}>
                      Search
                    </ContextButton>
                  </div>
                </div>
              </div>
              {searchResults.length === 0 && !showSpinner && (
                <div
                  style={{
                    textAlign: 'center',
                    width: '100%',
                  }}
                >
                  <h1 style={{ padding: '15px', fontWeight: 'bold' }}>
                    {hasSearchBeenMade
                      ? `No Records Found - Please Refine Search`
                      : `Please Search for Users to give XML API Access`}
                  </h1>
                </div>
              )}
              {showSpinner && (
                <div
                  style={{
                    height: '200px',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                  }}
                  className="form-blocks"
                >
                  <div>
                    <Spinner className="page-loader" themeColor="neutral" />
                  </div>
                </div>
              )}
              <div className="search-wrapper paper-process-result-wrapper">
                {searchResults.length > 0 &&
                  !showSpinner &&
                  searchResults.map((user, i) => {
                    const isUserConnected = !requirePayAccount || user.PayAccountNum !== null
                    return (
                      <div
                        key={i}
                        className={`stacked-data-result paper-process-result-item ${
                          isUserConnected ? `` : `disabled`
                        }`}
                        type="button"
                        onClick={() => {
                          if (isUserConnected) {
                            setShowSearchUserError(false)
                            selectUser(user)
                          } else {
                            setShowSearchUserError(true)
                          }
                        }}
                      >
                        <div className="row">
                          <div className={`search-result`}>
                            <span className="primary">{`${user.FirstName} ${user.LastName}`}</span>
                            <span className="secondary">{`Email: ${user.Username}`}</span>
                            {isUserConnected && (
                              <span className="secondary">{`Account Number: ${user.PayAccountNum}`}</span>
                            )}
                          </div>
                        </div>
                      </div>
                    )
                  })}
              </div>
              {showSearchUserError && (
                <div
                  style={{
                    textAlign: 'center',
                    width: '100%',
                  }}
                >
                  <h1
                    style={{ padding: '15px', fontWeight: 'bold' }}
                  >{`Selected user is NOT linked to a ${
                    frequentPayorLabel || 'Frequent Payor'
                  }!`}</h1>
                </div>
              )}
            </div>
          </div>
        </Modal>
      </Portal>
    </div>
  )
}

export default SettingsUserSearch
